/* eslint-disable no-unused-vars */
import React from "react";
import styles from "./styles.css";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import BenefitCard from "./benefit-card";
import PropTypes from "prop-types";

const LoanBenefits = ({ content, images }) => {
    const { tokens } = useTokens();
    const { title = "", benefits = [] } = content || {};
    return (
        <div styleName={"styles.loanBenefitsContainer"}>
            <div styleName={"styles.container"}>
                <Heading
                    level={NUMBER.TWO}
                    color={tokens.text_default_text_primary}
                    isBold
                >
                    {title || ""}
                </Heading>
                <div styleName={"styles.benefitsRow"}>
                    {benefits.map((benefit, index) => {
                        const icon =
                images.filter((img) => img.imageSlug === benefit.icon)?.[0] ||
                {};
                        return (
                            <BenefitCard
                                benefit={benefit}
                                key={index}
                                iconUrl={icon?.desktopImage || icon?.image}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

LoanBenefits.propTypes = {
    content: PropTypes.object,
    images: PropTypes.array
};

export default LoanBenefits;
